module.exports = __webpack_public_path__ + "static/media/video_consent_audio_odiya.f762122d.mp3";